import React, { useEffect } from "react";
import { Box, Typography, useTheme, Skeleton } from "@mui/material";
import { useStatisticsStore } from "../../../stores/statisticsStore";
import { BlockModalWrapper } from "../../../components/block-modal-wrapper/block-modal-wrapper";
import { timeItemBoxStyles, itemTextStyles, itemTimeStyles } from "./styles";

export const StatisticTimeCard: React.FC = () => {
  const theme = useTheme();
  const { timeSpent, isLoadingTimeSpent, errorTimeSpent, fetchTimeSpent } =
    useStatisticsStore();

  useEffect(() => {
    fetchTimeSpent();
  }, [fetchTimeSpent]);

  return (
    <BlockModalWrapper lable={"Statistics"} md={1}>
      {isLoadingTimeSpent ? (
        <Box>
          {Array.from({ length: 3 }).map((_, idx) => (
            <Box key={idx} sx={timeItemBoxStyles(idx, 3, theme)}>
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="40%" />
            </Box>
          ))}
        </Box>
      ) : errorTimeSpent ? (
        <Typography color="red">{errorTimeSpent}</Typography>
      ) : (
        timeSpent.map((item, index) => (
          <Box
            key={index}
            sx={timeItemBoxStyles(index, timeSpent.length, theme)}
          >
            <Typography sx={itemTextStyles}>{item.text}</Typography>
            <Typography sx={itemTimeStyles}>{item.time}</Typography>
          </Box>
        ))
      )}
    </BlockModalWrapper>
  );
};

export default StatisticTimeCard;
